import React from "react";
import FacebookIcon from "../../Assets/img/footer/Facebook.svg";
import PinterestIcon from "../../Assets/img/footer/pinterest.svg";

type BlogDetailShareProps = {
  shareUrl: string;
  title: string;
  imageUrl?: string;
};

const BlogDetailShare = ({ shareUrl, title, imageUrl }: BlogDetailShareProps) => {
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title);
  const encodedMedia = encodeURIComponent(imageUrl || shareUrl);

  const links = [
    {
      key: "facebook",
      href: `https://www.facebook.com/sharer.php?u=${encodedUrl}`,
      icon: FacebookIcon,
      label: "Share on Facebook",
    },
    {
      key: "pinterest",
      href: `https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedMedia}&description=${encodedTitle}`,
      icon: PinterestIcon,
      label: "Share on Pinterest",
    },
    {
      key: "twitter",
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      icon: null,
      label: "Share on X",
    },
  ];

  return (
    <div className="blog-detail-share" aria-label="Share this article">
      {links.map((item) =>
        item.icon ? (
          <a
            key={item.key}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={item.label}
            className={`blog-detail-share__link blog-detail-share__link--${item.key}`}
          >
            <img src={item.icon} alt="" width={22} height={22} />
          </a>
        ) : (
          <a
            key={item.key}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={item.label}
            className="blog-detail-share__link blog-detail-share__link--twitter"
          >
            <span className="blog-detail-share__x" aria-hidden="true">
              X
            </span>
          </a>
        )
      )}
    </div>
  );
};

export default BlogDetailShare;
